import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
export var showRemoveFavoritesIcons = function showRemoveFavoritesIcons(id) {
  var elems = document.querySelectorAll("a[class^=fav][data-id='".concat(id, "']"));
  elems.forEach(function (e) {
    if (e.classList.contains("fav-save")) e.style.display = "none";else if (e.classList.contains("fav-remove")) e.style.display = "block";
  });
};
export var showAddFavoritesIcon = function showAddFavoritesIcon(id) {
  var elems = document.querySelectorAll("a[class^=fav][data-id='".concat(id, "']"));
  elems.forEach(function (e) {
    if (e.classList.contains("fav-save")) e.style.display = "block";else if (e.classList.contains("fav-remove")) e.style.display = "none";
  });
};